import { render, staticRenderFns } from "./Cim.vue?vue&type=template&id=6224085e&scoped=true"
import script from "./Cim.vue?vue&type=script&lang=js"
export * from "./Cim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6224085e",
  null
  
)

export default component.exports